import { useLocation } from 'react-router-dom';

export const useEmbeddedLink = () => {
  const location = useLocation();
  const currentParams = new URLSearchParams(location.search);

  const embed = currentParams.get('embed');
  const etoken = currentParams.get('etoken');
  const lang = currentParams.get('lang');

  return (path: string) => {
    const [basePath, rawQuery] = path.split('?');
    const params = new URLSearchParams(rawQuery || '');

    if (embed) params.set('embed', embed);
    if (etoken) params.set('etoken', etoken);
    if (lang) params.set('lang', lang);

    return `${basePath}?${params.toString()}`;
  };
};